import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../../environments/environment';
import { ApiMethodService } from '../../../../tools/services/api/method-api/apiMethod.service';
import { ParkingRevenueMarketingDashboardDto } from '../../../models/finance/parking-revenue-marketing.model';

@Injectable({ providedIn: 'root' })
export class ApiParkingRevenueMarketingService {
  private readonly baseUrl = environment.apiPrivateUrl;
  private readonly cookieService = inject(CookieService);
  private readonly apiMethodService = inject(ApiMethodService);
  private readonly http = inject(HttpClient);

  getParkingRevenueMarketingDashboard(
    siteId: number,
    userId: number,
    startDate?: string,
    endDate?: string,
  ): Observable<ParkingRevenueMarketingDashboardDto> {
    const token = this.cookieService.get('token');
    const params: Record<string, string | number> = { siteId, userId };
    if (startDate) params['startDate'] = startDate;
    if (endDate) params['endDate'] = endDate;

    return this.apiMethodService.request<ParkingRevenueMarketingDashboardDto>(
      '/Backoffice/getParkingRevenueMarketingDashboard',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'getParkingRevenueMarketingDashboard',
        token,
        headerOnly: false,
        params,
      },
    );
  }

  getParkingRevenueMarketingPdf(params: {
    siteId: number;
    startDate: string;
    endDate: string;
  }): Observable<Uint8Array> {
    const httpParams = new HttpParams()
      .set('siteId', params.siteId)
      .set('startDate', params.startDate)
      .set('endDate', params.endDate);

    const headers = new HttpHeaders({
      Authorization: `Bearer ${this.cookieService.get('token')}`,
      Accept: 'application/octet-stream, application/pdf, */*',
    });

    return this.http
      .get(`${this.baseUrl}/Reports/parking-revenue-marketing/pdf`, {
        headers,
        params: httpParams,
        responseType: 'arraybuffer',
      })
      .pipe(map((buffer) => new Uint8Array(buffer)));
  }
}
